exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".img-arrow {\n  margin-left: 10rem !important; }\n\n.row {\n  margin: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/common-component/check-symbol/check-symbol.component.scss
// module id = ../../../../../src/app/common-component/check-symbol/check-symbol.component.scss
// module chunks = main